import { render, staticRenderFns } from "./FiltrosServicos.vue?vue&type=template&id=28cbcdfa&"
import script from "./FiltrosServicos.vue?vue&type=script&lang=js&"
export * from "./FiltrosServicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports